import { questionnaireLoaded } from "@teamprevent/common/questionnaires/actions";
import { REFERRAL_QUESTIONNAIRE_KEY } from "@teamprevent/common/questionnaires/components/referralForm/ReferralForm";
import { AnsweredQuestionWithId } from "@teamprevent/common/questionnaires/model";
import { Dispatch } from "redux";

import { actionTaskSuccess } from "./actions";

import ReferralApi from "./referralFormApi";

export const deleteReferralForm = (customerId: string, ohCaseId: string, reason: string) => {
    return async (dispatch: Dispatch) => {
        const response = await ReferralApi.deleteReferralForm(customerId, ohCaseId, reason);
        dispatch(actionTaskSuccess({ ohCaseId, tasks: [response] }));
    };
};

export const deleteReferralFormDocument = (customerId: string, ohCaseId: string, documentId: string, reason: string) => {
    return async (dispatch: Dispatch) => {
        const response = await ReferralApi.deleteReferralFormDocument(customerId, ohCaseId, documentId, reason);
        const questions = response.data.questions as AnsweredQuestionWithId[];
        const referralSubmittedDate = response.referralSubmittedDate;
        dispatch(questionnaireLoaded({ questions, questionnaireKey: REFERRAL_QUESTIONNAIRE_KEY, referralSubmittedDate }));
    };
};
